import {
  APPLICATION_SUMMERY_PAGE,
  PRIMARY_APPLICATION_SUMMERY_PAGE,
  QUESTIONAIRE_PAGE,
  SCHEDULE_INTERVIEW,
  SECONDARY_APPLICATION_SUMMERY_PAGE,
} from "../../../../utils/Constants/jobApplicationProcessSteps";

const SUMMARY_PAGE_IDS = new Set([
  APPLICATION_SUMMERY_PAGE,
  PRIMARY_APPLICATION_SUMMERY_PAGE,
  SECONDARY_APPLICATION_SUMMERY_PAGE,
]);

export const getApplicationDetailProgressSteps = ({
  applicationSteps = [],
  jobDetails = {},
}) =>
  applicationSteps.filter((page) => {
    if (SUMMARY_PAGE_IDS.has(page.id)) return false;
    if (page.removeFromNavigation) return false;

    if (page.id === QUESTIONAIRE_PAGE) {
      return jobDetails?.meta?.questionaireId != null;
    }

    if (page.id === SCHEDULE_INTERVIEW) {
      return jobDetails?.meta?.eventTypeId != null;
    }

    return true;
  });

export const navigateToApplicationStep = ({
  navigate,
  page,
  candidateData,
  onClose,
}) => {
  if (!page?.path) return false;

  navigate(page.path, {
    state: { candidateData },
  });
  onClose?.();
  return true;
};
